'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var common = {
    pushHistory: new Event('pushHistory'),
    clearFilter: new Event('clearFilter'),
    createElement: function createElement(tagName, parentElement, params) {
        // Create element helper, to simplify this process
        if (!tagName || !parentElement) return null;

        var element = document.createElement(tagName);
        if (params) {
            Object.assign(element, params);
        }
        parentElement.appendChild(element);
        return element;
    },
    getFacetsFromStore: function getFacetsFromStore() {
        var cartBasic = common.getCartBasic();
        return cartBasic ? cartBasic.facets : null;
    },
    getCartData: function getCartData() {
        var cartBasic = common.getCartBasic();
        return cartBasic ? cartBasic.cart : null;
    },
    getCartBasic: function getCartBasic() {
        try {
            var storeData = _store2.default.get();
            return storeData.getState();
        } catch (e) {
            console.error('Cart state was not loaded.', e);
            return null;
        }
    },
    sortByStringParam: function sortByStringParam(array, paramName) {
        var collator = Intl.Collator();

        return array.sort(function (a, b) {
            return collator.compare(a[paramName], b[paramName]);
        });
    },
    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
        var result = '';
        for (var p = 0; p < inputString.length; p++) {
            var currentChar = inputString.charAt(p);
            var charIndex = diacriticsChars.indexOf(currentChar);
            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
        }
        return result;
    },
    showMessageOrNotify: function showMessageOrNotify(severity, showAsPopup, title, messageText, options) {
        switch (severity.toLowerCase()) {
            case 'warn':
            case 'warning':
                if (showAsPopup) _message2.default.warn(messageText, title, options);else _notify2.default.warn(messageText, title, options);
            case 'err':
            case 'error':
            default:
                if (showAsPopup) _message2.default.error(messageText, title, options);else _notify2.default.error(messageText, title, options);
        }
    },

    batchReplace: function batchReplace(originalText, replacementObject) {
        if (!originalText || !replacementObject || !Array.isArray(replacementObject)) return originalText;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = replacementObject[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var replacement = _step.value;

                originalText = originalText.replaceAll(replacement.original, replacement.replacement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return originalText;
    },
    getQueryStringParam: function getQueryStringParam(paramName) {
        return common.getParamFromUrl(document.location.href, paramName);
    },
    getParamFromUrl: function getParamFromUrl(url, paramName) {
        var questionMarkIndex = url.indexOf('?');
        if (questionMarkIndex < -1) return '';

        var queryString = url.substr(questionMarkIndex);

        var rex = new RegExp(paramName + '=[^&]+', 'gi');
        var paramAndValue = rex.exec(queryString);
        if (!paramAndValue || paramAndValue.length < 1) return '';

        return paramAndValue[0].split('=')[1];
    },
    testIntInString: function testIntInString(input) {
        return (/^[0-9]+$/.test(input)
        );
    },

    updateSearchQueryByUrl: function updateSearchQueryByUrl(url) {
        var destElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#mainContent";

        var data = { ajaxElement: destElement };
        window.history.pushState(data, '', url);
        (0, _store.dispatchAction)(_extends({ type: 'NAVIGATOR/NAVIGATE', uri: url }, data));
        window.dispatchEvent(common.pushHistory);
    },

    setupUpdateSearchUrlByObject: function setupUpdateSearchUrlByObject(filterObject) {
        var filter = filterObject ? '?filter=' + JSON.stringify(filterObject).substring(1).slice(0, -1) : '';
        return '' + location.origin + location.pathname + filter;
    },

    updateSearchQuery: function updateSearchQuery(currentFilterItemRegex, selectedValues) {
        var filterName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Categories';
        var destElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "#mainContent";

        var otherParams = common.getFilterUrlExceptRegex(currentFilterItemRegex);
        if (otherParams) otherParams = ',' + otherParams;
        // call server with url assembled from host and category values from model (selectedCategories)
        var url = '' + location.origin + location.pathname + '?filter="' + filterName + '":[' + selectedValues.map(function (e) {
            return '"' + e + '"';
        }) + ']' + (otherParams || '');
        common.updateSearchQueryByUrl(url, destElement);
    },

    getFilterUrlExceptRegex: function getFilterUrlExceptRegex(currentFilterItemRegex) {
        var filterParam = common.getQueryStringParam('filter');
        if (!filterParam) return null;
        return unescape(filterParam).replace(currentFilterItemRegex, '');
    },

    loadSelectedFiltersFromUrl: function loadSelectedFiltersFromUrl(currentFilterRegex) {
        var filterParam = common.getQueryStringParam('filter');
        if (!filterParam) return [];

        filterParam = unescape(filterParam).match(currentFilterRegex);
        var filterParamMatch = void 0;
        if (!filterParam || filterParam.length < 0 || !(filterParamMatch = filterParam[0].match(/[0-9]+/g))) return [];

        return [].concat(_toConsumableArray(filterParamMatch));
    },

    getFilterParamRegex: function getFilterParamRegex(facetName) {
        return new RegExp("\"?" + facetName + "\"?:\[[0-9\"\',]*\],?", "ig");
    },

    formatIsoDateOnly: function formatIsoDateOnly(date) {
        if (typeof date.toISOString !== 'function') return '';
        var isoString = date.toISOString();
        return isoString && isoString.length > 10 ? isoString.slice(0, 10) : '';
    },

    hideItemPlaceHolderByClass: function hideItemPlaceHolderByClass(addToCartInput, missingInCartRowId) {
        var hiddenCLassName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'missing-in-cart-row-hidden';

        if (!addToCartInput) return;

        var currentPlaceHolder = addToCartInput.closest('tr') || addToCartInput.closest('.products-view-grid>div.item');
        var wrap = addToCartInput.closest('.' + hiddenCLassName);
        if (wrap !== null) return;

        // wrap TR for css styling for odd and even rows
        var wrapper = document.createElement('span'); // cannot be DIV or TR
        currentPlaceHolder.parentNode.insertBefore(wrapper, currentPlaceHolder);
        wrapper.appendChild(currentPlaceHolder);
        wrapper.classList.add(hiddenCLassName);
        wrapper.dataset.missingInCartRowId = missingInCartRowId;
    },

    loadObjectFilter: function loadObjectFilter() {
        var queryStringParamName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'filter';

        try {
            var filterParam = unescape(common.getQueryStringParam(queryStringParamName));
            if (filterParam.endsWith(',')) filterParam = filterParam.slice(0, -1);

            return JSON.parse('{' + filterParam + '}');
        } catch (e) {
            console.error('Error in parsing filter query to JSON.', e);
            return {};
        }
    },

    highLightActiveFilterButton: function highLightActiveFilterButton(isActive, button) {
        if (isActive) button.classList.add('selected-popup-facet');else button.classList.remove('selected-popup-facet');
    }
};

exports.default = common;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/utils/common.js
// module id = 460
// module chunks = 0